import CoverSection from './cover-section';


export default (di) => {
	di
		.setType({type: CoverSection, name: 'CoverSection', parent: 'PageComponent'})
	;
};
